import { render, staticRenderFns } from "./userAgreement.vue?vue&type=template&id=70c3e38c&scoped=true"
import script from "./userAgreement.vue?vue&type=script&lang=js"
export * from "./userAgreement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70c3e38c",
  null
  
)

export default component.exports